module.exports = __webpack_public_path__ + "img/nav-profile.2633c162.svg";